import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseCRUDService } from '../../services/base-crud.service';
import { ValidDocuments } from '../check-requirements/valid-documents.model';
import { CountryCard } from './country-card.model';

@Injectable({
    providedIn: 'root'
})
export class CountryCardService extends BaseCRUDService<CountryCard> {

    constructor(http: HttpClient) {
        super(http, 'countrycard');
    }

    getAll(): Observable<CountryCard[]> {
        throw new Error('Not implemented');
    }

    // ritorna le country card della company specificata
    getByCompanyId(companyId: number): Observable<CountryCard[]> {
        return this.http.get<CountryCard[]>(this.baseUrl + `/getall/bycompanyid/${companyId}`);
    }

    // ritorna i certificati ed i record di sanità pubblica validi dell'utente specificato
    getValidDocuments(userId: string, from: string, to: string): Observable<ValidDocuments> {
        return this.http.get<ValidDocuments>(this.baseUrl + `/getalldocuments/byuserid/${userId}/${from}/${to}`);
    }
}
